var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Poptip',{attrs:{"confirm":"","placement":"top-end","title":"确认删除？","ok-text":"确认","cancel-text":"取消"},on:{"on-ok":function($event){return _vm.$emit('ok')}}},[_c('Button',[_vm._v("删除")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }